(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3184],{

/***/ 6445:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/custom-software-development",
      function () {
        return __webpack_require__(642);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SuccessStoryEmbed; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _blogs_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2684);





var allCaseStudies = _blogs_json__WEBPACK_IMPORTED_MODULE_3__.filter(function(item) {
    var ref;
    return (item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category) === "case-study";
}).map(function(item) {
    return {
        title: item.meta.title || "",
        slug: item.meta.slug || "",
        img: item.meta.img || null,
        industry_descriptor: item.meta.industry_descriptor || null,
        outcome_metric: item.meta.outcome_metric || null,
        refer: Array.isArray(item.meta.refer) ? item.meta.refer : [],
        date: item.meta.date || ""
    };
});
function SuccessStoryEmbed(param) {
    var referTag = param.referTag, _maxItems = param.maxItems, maxItems = _maxItems === void 0 ? 3 : _maxItems, _heading = param.heading, heading = _heading === void 0 ? "Work we've shipped for clients like you" : _heading;
    var stories = referTag ? allCaseStudies.filter(function(s) {
        return s.refer.includes(referTag);
    }) : [];
    if (stories.length === 0) {
        stories = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(allCaseStudies).sort(function(a, b) {
            return b.date > a.date ? 1 : -1;
        });
    }
    var visible = stories.slice(0, maxItems);
    if (!visible.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "py-12 px-6 md:px-[60px] bg-gray-50 text-left",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-6xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-left",
                    children: heading
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-3 gap-6 mb-8",
                    children: visible.map(function(story) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/blog/".concat(story.slug),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                className: "group bg-white border border-gray-200 rounded-xl overflow-hidden hover:border-blue-400 hover:shadow-md transition-all flex flex-col",
                                children: [
                                    story.img && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "relative w-full h-44 bg-gray-100",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            src: story.img,
                                            alt: story.title,
                                            fill: true,
                                            className: "object-cover",
                                            sizes: "(max-width: 768px) 100vw, 400px",
                                            placeholder: "blur",
                                            blurDataURL: "/blogImages/hero/placeholder.webp"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "p-5 flex flex-col flex-1",
                                        children: [
                                            story.industry_descriptor && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-blue-500 text-xs uppercase tracking-wide font-medium mb-2",
                                                children: story.industry_descriptor
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "text-base font-semibold text-gray-900 group-hover:text-blue-600 transition-colors leading-snug mb-3 flex-1",
                                                children: story.title
                                            }),
                                            story.outcome_metric && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-sm text-gray-500 mt-auto pt-3 border-t border-gray-100",
                                                children: story.outcome_metric
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, story.slug);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/success-stories",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "inline-block border border-gray-300 hover:border-blue-500 text-gray-700 hover:text-blue-600 font-semibold px-7 py-3 rounded-lg transition-colors text-sm",
                            children: "See all success stories →"
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ customSoftwareDevelopment; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_blogUtils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1180);
/* harmony import */ var _blogs_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2684);
/* harmony import */ var _components_services_Service2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3230);
/* harmony import */ var _components_trust_SuccessStoryEmbed__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2100);
/* harmony import */ var _components_services_ServiceFAQ__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2616);
/* harmony import */ var _components_services_ServiceEngagementLinks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5733);
/* harmony import */ var _components_ai_agent_demo_CustomerSection__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4837);








var Capabilities2 = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5791), __webpack_require__.e(8388), __webpack_require__.e(5290), __webpack_require__.e(7517), __webpack_require__.e(7113)]).then(__webpack_require__.bind(__webpack_require__, 7517));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7517)
            ];
        }
    },
    ssr: false
});




var Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 2941).then(__webpack_require__.bind(__webpack_require__, 3193));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3193)
            ];
        }
    },
    ssr: false
});
customSoftwareDevelopment.title = "Custom Software Development & Enterprise Engineering | ITMTB";
customSoftwareDevelopment.desc = "ITMTB builds custom software for enterprises — greenfield platforms, web and mobile apps, and AI-enabled systems — engineered for lifecycle ownership, not just delivery. Pune & Bhopal.";
customSoftwareDevelopment.header_img = "https://www.itmtb.com/services/capability/automate.webp";
customSoftwareDevelopment.keywords = "custom software development company India, custom software development Pune, custom software development Bhopal, enterprise software engineering India, bespoke software development India, AI-enabled software development India";
var faqItems = [
    {
        q: "What kinds of custom software does ITMTB build?",
        a: "Greenfield platforms, customer-facing and operational applications (web and mobile), bespoke enterprise systems, AI-enabled products, and the integrations that connect them — across BFSI, pharma, retail, supply chain, and manufacturing. The common thread is that off-the-shelf software either doesn't fit the process well enough or doesn't exist for it. We scope whether a custom build is genuinely warranted versus configuring an existing platform during the discovery sprint, and give you a direct recommendation either way."
    },
    {
        q: "How do you price a custom software project?",
        a: "Through fixed-scope phases, capped time-and-materials, or outcome-linked retainers depending on how defined the scope is. Every engagement starts with a fixed-price discovery sprint, so you have a written estimate before committing to a build. Total cost is driven by scope, integration complexity, QA depth, and post-launch support rather than headcount — and we scope for what the system costs to own over five years, not just what it costs to ship in the first three months.",
        link: "/blog/custom-software-development-cost-india",
        linkLabel: "Read the cost guide"
    },
    {
        q: "Do you work with companies outside Pune and Bhopal?",
        a: "Yes. Our offices are in Pune and Bhopal, and we deliver custom software for clients across India and, on selected engagements, internationally. Whether you're nearby and want to meet in person or you're running a fully distributed engagement, the delivery model is the same: scoped, governed, and owned end to end."
    },
    {
        q: "How long does a custom software project take?",
        a: "A fixed-scope first phase typically runs 4–8 weeks to production — the smallest shippable slice in real use before any larger commitment. Larger platforms are scoped from there based on complexity, integration surface, and the number of domains involved. The discovery sprint (typically two weeks, fixed price) produces a precise estimate and timeline for your specific system before any build begins."
    },
    {
        q: "Do you maintain the software after launch?",
        a: "Yes. Every implementation ships with a 4–8 week post-deployment warranty period — defects and regressions fixed at no cost. Beyond that, optional managed-services engagements cover ongoing operation, monitoring, and evolution. We engineer for handover from day one: documentation, runbooks, and operational readiness so you're never dependent on us to run what we build.",
        link: "/services/managed-services",
        linkLabel: "See managed services"
    },
    {
        q: "How is this different from a development agency?",
        a: "We scope for lifecycle ownership rather than just shipping a build. Most software cost arrives after launch — support, defects, infrastructure, regression, maintenance — so we engineer to reduce that downstream drag: structured QA and release governance, observability built into delivery, documentation and operational readiness, and security architecture appropriate to regulated environments. The result is a system designed to run for years, not a prototype handed off for you to maintain alone."
    },
    {
        q: "What does an engagement with ITMTB look like?",
        a: "Every engagement starts with a fixed-scope, fixed-price discovery sprint — typically 2 weeks. You leave with a written roadmap, risk register, cost estimate, and timeline before committing to a build. We then offer four engagement models: fixed-scope builds, time-and-materials with a budget cap, outcome-linked retainers, and managed services post-launch. If discovery doesn't justify proceeding, you can stop there — no obligation.",
        link: "/itmtb-how-we-work",
        linkLabel: "See how we work"
    }, 
];
customSoftwareDevelopment.faq = faqItems;
var jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
        {
            "@type": "Service",
            serviceType: "Custom Software Development",
            name: "Custom Software Development",
            provider: {
                "@type": "Organization",
                name: "Itmtb Technologies Private Limited",
                url: "https://www.itmtb.com",
                logo: "https://www.itmtb.com/logo.webp",
                sameAs: [
                    "https://www.linkedin.com/company/itmtb-technologies/",
                    "https://x.com/ITMTBTech",
                    "https://www.instagram.com/itmtbtech/", 
                ]
            },
            areaServed: [
                {
                    "@type": "City",
                    name: "Pune"
                },
                {
                    "@type": "City",
                    name: "Bhopal"
                },
                {
                    "@type": "Country",
                    name: "India"
                }, 
            ],
            url: "https://www.itmtb.com/services/custom-software-development",
            description: "Custom software development for enterprises — greenfield platforms, web and mobile applications, and AI-enabled systems, engineered for lifecycle ownership."
        },
        {
            "@type": "BreadcrumbList",
            itemListElement: [
                {
                    "@type": "ListItem",
                    position: 1,
                    name: "Home",
                    item: "https://www.itmtb.com"
                },
                {
                    "@type": "ListItem",
                    position: 2,
                    name: "Services",
                    item: "https://www.itmtb.com/capabilities"
                },
                {
                    "@type": "ListItem",
                    position: 3,
                    name: "Custom Software Development",
                    item: "https://www.itmtb.com/services/custom-software-development"
                }, 
            ]
        }, 
    ]
};
var activities = [
    "Greenfield platforms",
    "Web applications",
    "Mobile applications",
    "Bespoke enterprise systems",
    "AI-enabled products",
    "System integration",
    "API engineering",
    "Release governance",
    "Production operations", 
];
var buildAreas = [
    {
        title: "Greenfield platforms",
        desc: "New products and internal systems built from the ground up, architected for scale from day one rather than retrofitted once they outgrow a prototype."
    },
    {
        title: "Customer-facing and operational platforms",
        desc: "The web and mobile platforms your customers and operations run on — engineered for enterprise load and lifecycle ownership, not one-off delivery. Built with the QA, release governance, and observability that enterprise scale demands."
    },
    {
        title: "Custom enterprise systems",
        desc: "Bespoke workflow, data, and operations software for processes where off-the-shelf doesn't fit and configuring a packaged product would produce something unmaintainable."
    },
    {
        title: "AI-enabled products",
        desc: "Software with agentic and automation capabilities built in, not bolted on — agents that act on live business data through engineered, testable interfaces."
    },
    {
        title: "System integration",
        desc: "Connecting custom software cleanly into the platforms you already run — ERPs, CRMs, payment rails, and data stores — so new systems extend the estate instead of fragmenting it."
    }, 
];
var engineeringPrinciples = [
    {
        title: "Structured QA and release governance",
        desc: "Regression validation, release gating, and defined quality bars — the difference between software that ships once and software that keeps shipping safely."
    },
    {
        title: "Observability and deployment maturity",
        desc: "Monitoring, logging, and deployment automation built into delivery so failures are visible and recoverable, not discovered by your users first."
    },
    {
        title: "Documentation and operational readiness",
        desc: "Architecture docs, runbooks, and knowledge transfer so you can run what we build — independent of us — from the day it goes live."
    },
    {
        title: "Security and access architecture",
        desc: "Access control, data handling, and compliance-aware design appropriate to regulated environments — BFSI, pharma, and supply chain — built in from the start."
    }, 
];
var engagementModels = [
    {
        title: "Fixed-scope first phase",
        duration: "4–8 weeks \xb7 Fixed price",
        desc: "The smallest shippable slice in production before any larger commitment — so risk is proven down before scope expands."
    },
    {
        title: "Time & materials with a budget cap",
        duration: "Flexible scope \xb7 Pre-agreed ceiling",
        desc: "Flexible scope within an agreed ceiling, with no invoice surprises — for work where requirements are still evolving."
    },
    {
        title: "Post-deployment warranty",
        duration: "4–8 weeks post-handoff",
        desc: "Implementation defects and regressions fixed at no cost during the warranty period after handoff."
    },
    {
        title: "No overhead billing",
        duration: "People on your project",
        desc: "You pay for people working on your project, not internal coordination or layers that don't touch the code."
    }, 
];
var subServices = [
    {
        img: null,
        key: "Greenfield Platform Engineering",
        title: "New products and internal systems, architected for scale from the first decision — not retrofitted once they outgrow a prototype.",
        text: "We build greenfield platforms from the ground up: domain modelling, architecture, build, and production deployment. The early architecture decisions are where most long-term cost is set — so we make them deliberately, with scale, integration, and operational ownership in view from day one.\n\nThis is for products and internal systems where you're not adapting an existing tool, you're building the thing itself — and it has to run reliably for years, not demo once."
    },
    {
        img: null,
        key: "Customer-Facing & Operational Platforms",
        title: "The platforms your customers and operations run on — engineered for enterprise load and lifecycle ownership, not one-off delivery.",
        text: "Web and mobile are delivery surfaces; the product is the system behind them — the data models, APIs, release governance, and observability that let a customer-facing or operational platform carry real business load and keep working as it evolves.\n\nThis is the difference between an application that demos well and one that holds up in production under real users, real data, and continuous change — with the QA and deployment maturity that enterprise use demands."
    },
    {
        img: null,
        key: "Custom Enterprise Systems",
        title: "Bespoke workflow, data, and operations software for processes where off-the-shelf doesn't fit.",
        text: "Custom development is justified when a process is genuinely unique and a packaged product would require so much customisation it becomes unmaintainable — a proprietary logistics platform, a custom risk engine, a bespoke workflow connecting systems no product supports.\n\nWe scope whether custom is the right call versus configuring an existing platform during the discovery sprint, and give you an honest recommendation. Where custom is warranted, we build production-grade systems with proper testing, monitoring, and documentation."
    },
    {
        img: null,
        key: "AI-Enabled Products",
        title: "Software with agentic and automation capabilities built in, not bolted on.",
        text: "We build software where AI is part of the architecture rather than a feature added at the end: agents that act on live business data, automation embedded in core workflows, and the engineered interfaces that let them do so safely.\n\nNon-deterministic systems need different engineering — behavioural testing, output validation, cost and latency guardrails, and clear boundaries on what an agent is allowed to do. We build for that from the start."
    },
    {
        img: null,
        key: "System Integration",
        title: "Connecting custom software cleanly into the platforms you already run.",
        text: "Most custom software doesn't run in isolation — it has to reach into ERPs, CRMs, payment rails, data stores, and third-party services. We build versioned, testable integration layers so new systems extend your estate instead of fragmenting it.\n\nThis includes API engineering, event streaming for real-time data, and the access and security architecture that integration across systems requires."
    }, 
];
function customSoftwareDevelopment() {
    var insights = _blogs_json__WEBPACK_IMPORTED_MODULE_4__.filter(function(item) {
        var ref;
        return ![
            "case-study",
            "tech"
        ].includes(item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category);
    });
    var caseStudies = _blogs_json__WEBPACK_IMPORTED_MODULE_4__.filter(function(item) {
        var ref;
        return (item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category) === "case-study";
    });
    insights = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_10__/* .getRandom */ .s)(insights, 2);
    caseStudies = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_10__/* .getRandom */ .s)(caseStudies, 2);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(jsonLd)
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_Service2__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                heading: "Custom Software Development",
                paragraph: '<span style="display:block;font-weight:600;color:#1e293b;margin-bottom:16px">Enterprise-grade systems, built to own — not just ship.</span>We design and build custom software for organisations that need systems they can depend on for years — not a prototype, and not a hand-off you\'re left to maintain alone. From the first architecture decision through production deployment and sustained operation, we own the engineering lifecycle with you.<ul style="margin-top:16px;padding-left:20px;list-style:disc;display:flex;flex-direction:column;gap:8px"><li>Greenfield platforms, customer-facing and operational systems, and AI-enabled products</li><li>Engineered for lifecycle ownership — QA, observability, and handover built in</li><li>Fixed-price discovery sprint before any larger commitment</li><li>Delivered from Pune &amp; Bhopal, across India and internationally</li></ul>',
                primaryCta: {
                    label: "Describe what you're building →",
                    href: "/contact-us?utm_source=service-custom-software-development&utm_content=hero-cta"
                },
                heroSvg: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    viewBox: "0 0 440 400",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    className: "w-full max-w-md opacity-70",
                    "aria-hidden": "true",
                    role: "presentation",
                    children: [
                        (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(Array(6)).map(function(_, row) {
                            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(Array(7)).map(function(_, col) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                    cx: 40 + col * 60,
                                    cy: 40 + row * 60,
                                    r: "1.5",
                                    fill: "#e2e8f0"
                                }, "".concat(row, "-").concat(col));
                            });
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "220",
                            cy: "200",
                            r: "150",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5",
                            strokeDasharray: "4 4"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "220",
                            cy: "50",
                            r: "9",
                            stroke: "#94a3b8",
                            strokeWidth: "1.5",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "350",
                            cy: "125",
                            r: "9",
                            stroke: "#94a3b8",
                            strokeWidth: "1.5",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "350",
                            cy: "275",
                            r: "9",
                            stroke: "#94a3b8",
                            strokeWidth: "1.5",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "220",
                            cy: "350",
                            r: "9",
                            stroke: "#94a3b8",
                            strokeWidth: "1.5",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "90",
                            cy: "275",
                            r: "9",
                            stroke: "#94a3b8",
                            strokeWidth: "1.5",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "90",
                            cy: "125",
                            r: "9",
                            stroke: "#94a3b8",
                            strokeWidth: "1.5",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 90 125 A 150 150 0 0 1 220 50",
                            stroke: "#b45309",
                            strokeWidth: "2.5",
                            fill: "none"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "220",
                            cy: "200",
                            r: "34",
                            stroke: "#b45309",
                            strokeWidth: "1",
                            strokeOpacity: "0.3",
                            strokeDasharray: "5 3"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "220",
                            cy: "200",
                            r: "22",
                            stroke: "#b45309",
                            strokeWidth: "2"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "220",
                            cy: "200",
                            r: "8",
                            fill: "#b45309",
                            fillOpacity: "0.15",
                            stroke: "#b45309",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 220 72 L 220 178",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 333 134 L 240 188",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 333 266 L 240 212",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 220 328 L 220 222",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 107 266 L 200 212",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 107 134 L 200 188",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                className: "bg-white border-b border-gray-100 px-6 md:px-[60px] py-2 overflow-x-auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex gap-6 text-sm font-medium whitespace-nowrap",
                    children: [
                        {
                            label: "What we build",
                            href: "#what-we-build"
                        },
                        {
                            label: "How we engineer",
                            href: "#how-we-engineer"
                        },
                        {
                            label: "How we engage",
                            href: "#how-we-engage"
                        },
                        {
                            label: "Where it goes deeper",
                            href: "#goes-deeper"
                        },
                        {
                            label: "FAQ",
                            href: "#faq"
                        }, 
                    ].map(function(param) {
                        var label = param.label, href = param.href;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: href,
                            className: "text-gray-500 hover:text-indigo-600 transition-colors py-1",
                            children: label
                        }, href);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ai_agent_demo_CustomerSection__WEBPACK_IMPORTED_MODULE_9__/* .CustomerSection */ .a, {
                title: "Trusted by"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-12 bg-white border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-5",
                            children: "What is custom software development?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-4",
                            children: "Custom software development is the design and engineering of software built specifically for an organisation's processes — rather than configuring an off-the-shelf product — covering everything from new greenfield platforms to customer-facing and operational applications, bespoke enterprise systems, and AI-enabled products."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-4",
                            children: [
                                "The work is far more than a single build. The decisions that matter most — architecture, integration, quality, and operational readiness — determine what the system costs to own long after launch. Most software cost arrives ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                    children: "after"
                                }),
                                " the first release: support, defects, infrastructure, regression, and maintenance — the",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/blog/custom-software-development-cost-india",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "text-indigo-600 font-medium hover:text-indigo-800 transition-colors",
                                        children: "total cost of ownership"
                                    })
                                }),
                                " ",
                                "that buyers routinely underestimate. Custom software development done well scopes for that whole lifecycle, not just the first three months of delivery."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed",
                            children: "ITMTB builds and operates custom software for enterprises across BFSI, pharma, retail, supply chain, and manufacturing — delivered from offices in Pune and Bhopal, for clients across India and, on selected engagements, internationally."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: "what-we-build",
                className: "scroll-mt-24 px-8 md:px-[60px] py-14 bg-gray-50 border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-6",
                            children: "What We Build"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-10",
                            children: "Custom software development covers far more than a single build. We work across the full range of enterprise engineering — with one common thread: we scope for what the system costs to own over five years, not just what it costs to build in the first three months."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "space-y-10",
                            children: buildAreas.map(function(area) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-lg font-bold text-gray-900 mb-2",
                                            children: area.title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-gray-600 text-base leading-relaxed",
                                            children: area.desc
                                        })
                                    ]
                                }, area.title);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-xs font-semibold uppercase tracking-widest text-gray-400 mt-12 mb-5",
                            children: "Typical custom software activities"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3",
                            children: activities.map(function(activity) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center gap-3 bg-white border border-gray-100 rounded-lg px-4 py-3",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "w-1.5 h-1.5 rounded-full bg-indigo-400 flex-shrink-0"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-sm text-gray-700",
                                            children: activity
                                        })
                                    ]
                                }, activity);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: "how-we-engineer",
                className: "scroll-mt-24 px-8 md:px-[60px] py-14 bg-white border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-5xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-6",
                            children: "How We Engineer"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-10",
                            children: [
                                "Most software cost arrives ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                    children: "after"
                                }),
                                " launch — support, defects, infrastructure, regression, maintenance. We engineer to reduce that downstream drag, so the system you ship is the system you can keep running."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-2 gap-6",
                            children: engineeringPrinciples.map(function(principle) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "bg-gray-50 border border-gray-200 rounded-xl p-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-base font-bold text-gray-900 mb-2",
                                            children: principle.title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-sm text-gray-600 leading-relaxed",
                                            children: principle.desc
                                        })
                                    ]
                                }, principle.title);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_trust_SuccessStoryEmbed__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                maxItems: 3,
                heading: "Selected custom software work"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-8 bg-white border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "max-w-4xl text-sm text-gray-500 leading-relaxed",
                    children: [
                        "For a regulated custom-build example, read how we designed a",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/blog/pharma-compliance-ai-sop-bmr-warning-letter-review",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "text-indigo-600 font-medium hover:text-indigo-800 transition-colors",
                                children: "pharma compliance AI platform for SOP and BMR review"
                            })
                        }),
                        " ",
                        "with versioned documents, traceable findings, and reviewer control."
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: "how-we-engage",
                className: "scroll-mt-24 px-8 md:px-[60px] py-14 bg-gray-50 border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-5xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-3",
                            children: "How We Engage"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-600 text-base md:text-lg mb-10",
                            children: "We structure engagements so contract risk matches the work — and so you prove risk down before scope expands. Every engagement starts with a fixed-scope, fixed-price discovery sprint."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-2 gap-6 mb-8",
                            children: engagementModels.map(function(model) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "bg-white border border-gray-200 rounded-xl p-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-xs font-semibold uppercase tracking-widest text-indigo-500 mb-2",
                                            children: model.duration
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-base font-bold text-gray-900 mb-2",
                                            children: model.title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-sm text-gray-600 leading-relaxed",
                                            children: model.desc
                                        })
                                    ]
                                }, model.title);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/itmtb-how-we-work",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "inline-flex items-center text-sm font-semibold text-indigo-600 hover:text-indigo-800 transition-colors",
                                children: "See all engagement options →"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Capabilities2, {
                dataList: subServices,
                bg: "bg-[#402A6A]",
                insights: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(caseStudies).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(insights)),
                hideFooter: true,
                hideCardSubtitle: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: "goes-deeper",
                className: "scroll-mt-24 px-8 md:px-[60px] py-14 bg-white border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-5xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-3",
                            children: "Where It Goes Deeper"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-600 text-base md:text-lg mb-10",
                            children: "Custom software development is the umbrella. Several specialised practices sit beneath it — engage the one that matches where you are."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-2 gap-5",
                            children: [
                                {
                                    href: "/services/enterprise-applications",
                                    label: "Enterprise Applications",
                                    desc: "Modernising or extending an existing ERP or CRM — SAP, Microsoft Dynamics 365, Oracle — and making legacy systems agent-ready."
                                },
                                {
                                    href: "/services/cloud",
                                    label: "Cloud",
                                    desc: "The cloud layer your software runs on — architecture, migration, and operations on AWS, Azure, and GCP."
                                },
                                {
                                    href: "/services/quality-engineering",
                                    label: "Quality Engineering",
                                    desc: "Test automation and release quality — including testing strategies for non-deterministic AI systems."
                                },
                                {
                                    href: "/services/iot-and-digital-eng",
                                    label: "IoT & Digital Engineering",
                                    desc: "Connected devices, edge intelligence, and digital engineering for connected products."
                                },
                                {
                                    href: "/services/managed-services",
                                    label: "Managed Services",
                                    desc: "Run and evolve the software after launch — operations, monitoring, and ongoing support with defined SLAs."
                                }, 
                            ].map(function(link) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: link.href,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        className: "block bg-gray-50 border border-gray-200 rounded-xl p-6 hover:border-indigo-400 hover:shadow-sm transition-all group",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "text-base font-semibold text-gray-900 group-hover:text-indigo-600 transition-colors mb-2",
                                                children: link.label
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-sm text-gray-500 leading-relaxed",
                                                children: link.desc
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "mt-4 inline-block text-sm font-semibold text-indigo-500 group-hover:text-indigo-700 transition-colors",
                                                children: "Learn more →"
                                            })
                                        ]
                                    })
                                }, link.href);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-14 bg-gray-50 border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-5",
                            children: "Built in India, working with you wherever you are"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-6",
                            children: [
                                "We work from offices in ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                    children: "Pune"
                                }),
                                " and ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                    children: "Bhopal"
                                }),
                                ", delivering custom software for clients across India and, on selected engagements, internationally. Whether you're nearby and want to meet in person or you're running a distributed engagement, the delivery model is the same: scoped, governed, and owned end to end."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-gray-600",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "font-semibold text-gray-900",
                                    children: "Pune"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-gray-300",
                                    children: "\xb7"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "font-semibold text-gray-900",
                                    children: "Bhopal"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-gray-300",
                                    children: "\xb7"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "mailto:hello@itmtb.com",
                                    className: "text-indigo-600 hover:text-indigo-800 transition-colors",
                                    children: "hello@itmtb.com"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "faq",
                className: "scroll-mt-24",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_ServiceFAQ__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    items: faqItems
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_ServiceEngagementLinks__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-16 bg-[#0d0822]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-3xl mx-auto text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-xs font-semibold uppercase tracking-widest text-indigo-400 mb-5",
                            children: "Building something custom?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-white mb-5",
                            children: "Tell us what you need"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-slate-300 text-base md:text-lg leading-relaxed mb-8",
                            children: "We'll scope a fixed-price first phase before any larger commitment — the smallest shippable slice in production, so you prove the risk down before scope expands."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/contact-us?utm_source=service-custom-software-development&utm_content=bottom-cta",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "inline-block bg-[#f1aa4e] text-black font-semibold text-base px-8 py-3.5 rounded-md hover:bg-[#e09a3e] transition-colors",
                                children: "Describe what you're building →"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Footer, {})
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1608,8657,2684,1831,9774,2888,179], function() { return __webpack_exec__(6445); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);